import React from 'react'
import PropTypes from 'prop-types'

import { LoadingWave } from '../../components'
import { sleep } from '../../utils'

import CourseCard from './CourseCard'

export default class CanvasCourse extends React.Component {
  static propTypes = {
    canvasCoursenum: PropTypes.string.isRequired,
    getCanvasCourses: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  }

  state = {
    loading: false,
    courses: [],
    error: false,
    search: '',
  }

  _getCanvasCourses = async () => {
    try {
      this.setState({ loading: true })
      const [courses] = await Promise.all([
        this.props.getCanvasCourses(),
        sleep(1500), // to let the user read the changes
      ])
      this.setState({ courses })
    } catch (error) {
      console.error(error)
    } finally {
      this.setState({ loading: false })
    }
  }

  componentDidMount() {
    this._getCanvasCourses()
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="maxw-600px mx-auto text-center">
          <h4>Loading Canvas courses...</h4>
          <LoadingWave />
        </div>
      )
    }

    let courses = this.state.courses
    if (this.state.search) {
      const search = this.state.search.toLowerCase()
      courses = courses.filter(
        course =>
          course.name.toLowerCase().includes(search) ||
          course.course_code.toLowerCase().includes(search)
      )
    }

    return (
      <div>
        <div className="maxw-600px mx-auto text-center">
          <h4>Select Canvas Course</h4>
          <p>Which Canvas course would you like to connect?</p>
          <div className="input-group mb-5">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="fas fa-search" />
              </span>
            </div>
            <input
              className="form-control text-center"
              value={this.state.search}
              onChange={event => this.setState({ search: event.target.value })}
              placeholder="Search courses by title or code"
            />
            <div className="input-group-append">
              <button
                disabled={!this.state.search}
                className="btn btn-danger fs-sm"
                type="button"
                onClick={() => this.setState({ search: '' })}
              >
                <i className="fas fa-times" />
              </button>
            </div>
          </div>
        </div>
        <div className="row">
          {courses.length ? (
            courses.map(course => (
              <CourseCard
                key={course.id.toString()}
                canvasCoursenum={this.props.canvasCoursenum}
                course={course}
                onSubmit={this.props.onSubmit}
                submitting={this.props.submitting}
              />
            ))
          ) : (
            <h3 className="text-center m-auto">
              {this.state.search
                ? 'No matching courses found'
                : 'No courses found'}
            </h3>
          )}
        </div>
      </div>
    )
  }
}
